import React, {useState} from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Header from "../sections/Header";
import ExtraordinaryRegularisationBanner from "../components/ExtraordinaryRegularisationBanner";
import HomeSection from "../sections/HomeSection";
import ServicesSection from "../sections/ServicesSection";
import NewsSection from "../sections/NewsSection";
import TeamSection from "../sections/TeamSection";
import ContactSection from "../sections/ContactSection";
import Footer from "../sections/Footer";
import PaymentSection from "../sections/PaymentSection";
import FloatingSidebar from "../components/FloatingSidebar";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import {
    getOrganizationSchema,
    getBarcelonaOfficeSchema,
    getMadridOfficeSchema,
    getWebsiteSchema,
    getServiceSchemas,
    getBreadcrumbSchema
} from "../utils/structuredData";

export default function Index() {
    const [isDarkMode, setIsDarkMode] = useState(false);
    const { i18n, t } = useTranslation();
    const location = useLocation();
    
    const currentLang = i18n.language || 'en';
    const baseUrl = process.env.REACT_APP_BASE_URL || 'https://livespainvisa.com';
    const currentUrl = `${baseUrl}${location.pathname}`;
    
    const seoData = {
        en: {
            title: "Immigration Lawyer Spain | Visa & Residency Services Barcelona & Madrid",
            description: "Expert immigration lawyers in Barcelona and Madrid. Services: work visas, digital nomad visa, business visas, study visas, retirement visas, Spanish citizenship, regularisation, and arraigo. Over 10 years experience helping people move to Spain.",
            keywords: "immigration lawyer Spain, visa lawyer Spain, Spanish residency lawyer, immigration lawyer Barcelona, immigration lawyer Madrid, work visa Spain, digital nomad visa Spain, Spanish citizenship lawyer, regularisation Spain, arraigo Spain, start business Spain, study visa Spain, retire Spain visa, Spanish residency permit, visa services Spain"
        },
        es: {
            title: "Abogado Inmigración España | Servicios Visa y Residencia Barcelona & Madrid",
            description: "Abogados expertos en inmigración en Barcelona y Madrid. Servicios: visados de trabajo, visa nómada digital, visados empresariales, visados de estudio, visados de jubilación, nacionalidad española, regularización y arraigo. Más de 10 años de experiencia ayudando a personas a mudarse a España.",
            keywords: "abogado inmigración España, abogado visa España, abogado residencia española, abogado inmigración Barcelona, abogado inmigración Madrid, visa trabajo España, visa nómada digital España, abogado nacionalidad española, regularización España, arraigo España, emprender negocio España, visa estudio España, retirarse España visa, permiso residencia España, servicios visa España"
        }
    };
    
    const currentSeo = seoData[currentLang] || seoData.en;

    const toggleDarkMode = () => {
        const htmlElement = document.documentElement;

        if (htmlElement.classList.contains('dark')) {
            htmlElement.classList.remove('dark');
            localStorage.setItem('theme', 'light');
            setIsDarkMode(false);
        } else {
            htmlElement.classList.add('dark');
            localStorage.setItem('theme', 'dark');
            setIsDarkMode(true);
        }
    };

    // Structured data schemas
    const organizationSchema = getOrganizationSchema();
    const barcelonaOfficeSchema = getBarcelonaOfficeSchema();
    const madridOfficeSchema = getMadridOfficeSchema();
    const websiteSchema = getWebsiteSchema();
    const serviceSchemas = getServiceSchemas();
    const breadcrumbSchema = getBreadcrumbSchema([
        { name: currentLang === 'es' ? 'Inicio' : 'Home', url: baseUrl }
    ]);

    return (
        <>
            {/* SEO Meta Tags */}
            <SEO
                title={currentSeo.title}
                description={currentSeo.description}
                keywords={currentSeo.keywords}
                canonicalUrl={currentUrl}
                ogImage={`${baseUrl}/og-image.jpg`} // Update with actual OG image URL
                lang={currentLang}
                alternateLanguages={[
                    { lang: 'en', url: `${baseUrl}/` },
                    { lang: 'es', url: `${baseUrl}/` }
                ]}
            />
            
            {/* Structured Data - Organization */}
            <StructuredData data={organizationSchema} id="organization-schema" />
            
            {/* Structured Data - Barcelona Office */}
            <StructuredData data={barcelonaOfficeSchema} id="barcelona-office-schema" />
            
            {/* Structured Data - Madrid Office */}
            <StructuredData data={madridOfficeSchema} id="madrid-office-schema" />
            
            {/* Structured Data - Website */}
            <StructuredData data={websiteSchema} id="website-schema" />
            
            {/* Structured Data - Services */}
            {serviceSchemas.map((schema, index) => (
                <StructuredData key={index} data={schema} id={`service-schema-${index}`} />
            ))}
            
            {/* Structured Data - Breadcrumbs */}
            <StructuredData data={breadcrumbSchema} id="breadcrumb-schema" />
            
            <div>
                <ExtraordinaryRegularisationBanner />
                <Header isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
                <FloatingSidebar/>
                <HomeSection isDarkMode={isDarkMode}/>
                <ServicesSection/>
                <NewsSection/>
                <TeamSection/>
                <ContactSection/>
                <PaymentSection/>
                <Footer isDarkMode={isDarkMode} />
            </div>
        </>
    )
}
